<div class="padded-side-nav page-container">
    <app-navigation-tab #navBar [fireInitialEvent]="false" class="nav-bar" [tabConfig]="tabConfig"
        [loading]="navLoading" (onTabChanged)="changeTab($event.tab.title)"></app-navigation-tab>
    @if(currentTab==='Manage Devices in Tag') {
    @if (loading===false) {
    <h1>Manage devices for tag: {{SelectedTag?.Name}}</h1>
    <div class="tables-container">
        <div class="all-devices">
            <h2>All Devices</h2>
            <div class="all-devices-table" #scrollContainerAllDevices (scroll)="unselectedDevicesScrolled()">
                <tools-table #allDevicesTable [Selectable]="true" [Multiple]="true" [Data]="unselectedDevicesSubset"
                    [PrimaryColumn]="'id'" [Headers]="allDevicesHeader" [DisplayCount]="0" [DisplayAllData]="true"
                    [DetectDataChanges]="true" (Selected)="addSelectedFromAllDevices($event)"
                    [CustomSearchFn]="unselectedTablesSearchFn" [SelectDisabledFn]="selectDisabledFn"
                    [CustomClearFn]="unselectedTableClearFn" [SelectAll]="true"
                    (AllSelectedList)="allSelectedFromUnselectedDevices($event)" [LocalizeSelectAll]="true"
                    (Deselected)="deselectedFromUnselectedDevices($event)" [ClearSelectionOnClear]="false">
                </tools-table>
            </div>
        </div>
        <div class="button-container">
            <button mat-raised-button (click)="addDevicesToTag()" [disabled]="DevicesToBeAddedToTag.length===0"><span
                    class="material-icons">arrow_forward</span>Add
                To Tag</button>
            <button mat-raised-button (click)="removeDevicesFromTag()"
                [disabled]="DevicesToBeRemovedFromTag.length===0"><span class="material-icons">arrow_back</span>Remove
                From Tag</button>
            <button mat-raised-button class="save-button" (click)="saveChanges()">Save Changes</button>
        </div>
        <div class="selected-devices">
            <h2>Devices in tag: {{SelectedTag?.Name}}</h2>
            <div class="selected-devices-table" #scrollContainerSelectedDevices (scroll)="selectedDevicesScrolled()">
                <tools-table #tagDevicesTable [Selectable]="true" [Multiple]="true" [Data]="selectedDevicesSubset"
                    [PrimaryColumn]="'id'" [Headers]="selectedDevicesHeader" [DisplayCount]="0" [DisplayAllData]="true"
                    [DetectDataChanges]="true" (Selected)="addSelectedFromTagDevices($event)"
                    [CustomSearchFn]="selectedTablesSearchFn" [CustomClearFn]="selectedTableClearFn" [SelectAll]="true"
                    (AllSelectedList)="allSelectedFromSelectedDevices($event)" [LocalizeSelectAll]="true"
                    (Deselected)="deselectedFromSelectedDevices($event)" [ClearSelectionOnClear]="false">
                </tools-table>
            </div>
        </div>
    </div>

    }@else {
    <div class="loader">
        <mat-spinner></mat-spinner>
    </div>
    }
    }@else if(currentTab==="View Tag Devices"){
    <div class="action-container">
        <div style="width:90%;">
            <app-generic-table-header [config]="headerConfig" (refreshEvent)="setFilter($event)"
                (exportPressed)="generateReport()"></app-generic-table-header>
        </div>
        <div style="width: 5%;">
            <button matTooltipShowDelay="500" [disabled]="selectedDevices.length<=0||!allDevicesSelected"
                matTooltip="Reboot Selected Devices" mat-mini-fab
                [ngClass]="selectedDevices.length<=0||!allDevicesSelected?'disabled-button':'mini-buttons'"
                (click)="rebootDevices()">
                <mat-icon> restart_alt </mat-icon>
            </button>
        </div>
        <div style="width: 5%;">
            <button matTooltipShowDelay="500"
                [disabled]="(selectedDevices.length<=0 || selectedContainsDisabledDevice()) || !allDevicesSelected"
                matTooltip="Run Teltonika Task" mat-mini-fab
                [ngClass]="(selectedDevices.length<=0||selectedContainsDisabledDevice()) || !allDevicesSelected?'disabled-button':'mini-buttons'"
                (click)="runTeltonikaTask()">
                <mat-icon> terminal </mat-icon>
            </button>
        </div>
    </div>
    @if(showTable){

    <tools-table ApiPath="/teltonika/advanced/" [Headers]="headers" #devicesTable [Search]="false"
        [SortColumn]="sortColumn" [HTTPPost]="true" [HTTPData]="buildHTTPData()" [SavedSearch]="searchTerm"
        [Actions]="actions" [Desc]="sortDesc" [Slim]="true" [DisplayCount]="10" ExtraQuery="?teltonika=true"
        [Selectable]="true" [Multiple]="true" (Selected)="addSelected($event)" [sideTagConfig]="sideTagConfig"
        [SelectAll]="true" (AllSelected)="allDevicesSelected=$event"></tools-table>
    }@else {
    <div class="loader">
        <mat-spinner></mat-spinner>
    </div>
    }
    }
</div>